import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from 'app/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { Router, Event, NavigationEnd, ActivatedRoute } from '@angular/router';
import { GetStarted } from 'app/website/models/get-started.model';
import { GetStartedService } from 'app/website/services/get-started.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ToastService } from 'ng-uikit-pro-standard';
@Component({
  selector: 'site-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SiteNavbarComponent implements OnInit {
  currentUser;
  showGettingStart: boolean = false;
  getStartForm: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: [''],
    company: ['']
  })
  chosenPlan: any;
  loading: boolean = false;

  constructor(private userService: UserService, private formBuilder: FormBuilder, private _validationHandler:ValidationHandler, private getStartedService: GetStartedService,
    private router: Router, private activeRoute: ActivatedRoute, private toastrService: ToastService) { 
    this.currentUser = userService.currentUserValue;
    // setTimeout(() => {
    //   this.showGettingStart = true;
    // }, 5000);
    router.events.subscribe( (event: Event) =>{
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        let navigationEvent: NavigationEnd = event as NavigationEnd;
        if(!this.currentUser) {
          this.showGettingStart = false;
          // if (navigationEvent.urlAfterRedirects.includes('pricing')) {
          //   setTimeout(() => {
          //     this.showGettingStart = true;
          //   }, 7000);
          // }
        }
      }
    });

    getStartedService.choosenPlan.subscribe(r => {
      if(r != ''){
        this.chosenPlan = r;
        this.showGettingStart = true;
      }
    })
  }

  ngOnInit() {
  }

  getStart(Form) {
    this.loading = true;
    if (!Form.valid) {
      this._validationHandler.onSubmitCheck(Form);
      this.loading = false;
      return;
    }
    let model: GetStarted = {
      name: Form.value.name,
      email: Form.value.email,
      phone: (Form.value.phone && Form.value.phone.length != 0) ? Form.value.phone : undefined,
      company: (Form.value.company && Form.value.company.length != 0) ? Form.value.company : undefined,
      website_url: this.router.url.toString(),
      chosen_plan: this.chosenPlan ? this.chosenPlan : undefined,
      utm_campaign: this.activeRoute.snapshot.queryParams['utm_campaign'] ? this.activeRoute.snapshot.queryParams['utm_campaign'] : undefined,
      utm_medium: this.activeRoute.snapshot.queryParams['utm_medium'] ? this.activeRoute.snapshot.queryParams['utm_medium'] : undefined,
      utm_source: this.activeRoute.snapshot.queryParams['utm_source'] ? this.activeRoute.snapshot.queryParams['utm_source'] : undefined
    }
    this.getStartedService.getStart(model).subscribe(res => {
      this.loading = false;
      this.toastrService.success('We will get back to you shortly!', 'Sent' ,{positionClass: 'md-toast-top-right'});
      this.getStartForm.reset();
    },
    err => {
      this.toastrService.error('Couldn\'t send info', 'Error' ,{positionClass: 'md-toast-top-right'});
      this.loading = false;   
    });
  }

  logout() {
    this.userService.logout();
  }
}
